import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { apiBaseUrl } from '../../data/constants';
import BlueprintView from './BlueprintView';
import { fontFamilies } from '../../theme/fonts';

import { colors } from '../../theme/tokens';
const DARK = colors.textPrimary;

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: '100vh',
    background: colors.bgPage,
    padding: '40px 20px 60px',
    [theme.breakpoints.down('xs')]: { padding: '24px 14px 40px' },
  },
  card: {
    maxWidth: 560,
    margin: '0 auto',
    background: colors.bgSurface,
    borderRadius: 14,
    border: `1px solid ${colors.border}`,
    padding: '28px 26px',
    textAlign: 'center',
  },
}));

const BlueprintPublic: React.FC = () => {
  const classes = useStyles();
  const { slug } = useParams<{ slug: string }>();
  const [bp, setBp] = useState<any>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'missing'>(
    'loading',
  );

  useEffect(() => {
    // Plain fetch, not the authed ajax helper — this page must work for a
    // visitor with no account and no token.
    fetch(`${apiBaseUrl}/api/blueprints/public/${slug}`)
      .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
      .then((data) => {
        setBp(data);
        setStatus('ready');
      })
      .catch(() => setStatus('missing'));
  }, [slug]);

  if (status === 'loading') {
    return (
      <div className={classes.page}>
        <Box display="flex" justifyContent="center" pt={10}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (status === 'missing') {
    return (
      <div className={classes.page}>
        <div className={classes.card}>
          <Typography
            style={{
              fontFamily: fontFamilies.display,
              fontSize: 15,
              fontWeight: 700,
              color: DARK,
            }}
          >
            This blueprint isn&apos;t available
          </Typography>
          <Typography
            style={{ fontSize: 14, color: colors.textMuted, marginTop: 6 }}
          >
            The link may be wrong, or the student hasn&apos;t published their
            page yet.
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.page}>
      <BlueprintView bp={bp} />
    </div>
  );
};

export default BlueprintPublic;
